import {googleAnalyticsProvider, withAnalyticsTracker} from '@dynamynd/analytics';

export const withAnalyticsTrackerWeb = withAnalyticsTracker([googleAnalyticsProvider]);
